import { Injectable } from '@angular/core';
import { NavigationButton, NavigationDropdown, NavigationItem, NavigationLink, NavigationSubheading } from '../interfaces/navigation-item.interface';
import { Subject } from 'rxjs';
import icHome from '@iconify/icons-ic/twotone-home';
import icJobs from '@iconify/icons-ic/twotone-card-travel';
import icSearch from '@iconify/icons-ic/twotone-search';
import icDateRange from '@iconify/icons-ic/twotone-date-range';
import icGroups from '@iconify/icons-ic/baseline-groups';
import icAssessment from '@iconify/icons-ic/twotone-assessment';
import icSettings from '@iconify/icons-ic/twotone-settings';
import icHelpOutline from '@iconify/icons-ic/twotone-help-outline';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  items: NavigationItem[] = [];
  tabValue;

  private _openChangeSubject = new Subject<NavigationDropdown>();
  openChange$ = this._openChangeSubject.asObservable();

  constructor() {}

  triggerOpenChange(item: NavigationDropdown) {
    this._openChangeSubject.next(item);
  }

  isLink(item: NavigationItem): item is NavigationLink {
    return item.type === 'link';
  }

  isDropdown(item: NavigationItem): item is NavigationDropdown {
    return item.type === 'dropdown';
  }

  isSubheading(item: NavigationItem): item is NavigationSubheading {
    return item.type === 'subheading';
  }

  isButton(item: NavigationItem): item is NavigationButton {
    return item.type === 'button';
  }
  
  checkTabValue(value){
    this.tabValue=value;
  }
  
  passToCandidate_detail2(){
    return  this.tabValue;
  }

  // no longer used
  setupNavItems() {
    const loginUserData = JSON.parse(localStorage.getItem('UserInfo'));
    this.items = [
      {
        type: 'link',
        label: 'Home',
        userRole: '',
        route: '/home',
        icon: icHome,
        routerLinkActiveOptions: { exact: true },
      },
      {
        type: 'dropdown',
        label: 'Jobs',
        userRole: '',
        icon: icJobs,
        children: [
          {
            type: 'link',
            label: 'Job Dashboard',
            userRole: '',
            route: '/apps/jobs',
          },
          {
            type: 'button',
            label: 'Add Jobs',
            userRole: '',
            action: 'addJob',
          },
          {
            type: 'button',
            label: 'Add Job Approval',
            userRole: '',
            action: 'addJobApproval',
          },
          {
            type: 'link',
            label: 'My Jobs',
            userRole: '',
            route: '/apps/jobs/jobs-listing',
          },
        ],
      },
      {
        type: 'dropdown',
        label: 'Candidates',
        icon: icGroups,
        userRole: '',
        children: [
          // {
          //   type: 'link',
          //   label: 'Pending',
          //   userRole: loginUserData.role,
          //   route: '/apps/candidates/pending',
          // },
          {
            type: 'link',
            label: 'Candidates',
            userRole: loginUserData.role,
            route: '/apps/candidates/table',
          },
          {
            type: 'link',
            label: 'Onboarding',
            userRole: 8,
            route: '/apps/candidates/onboarding/card',
          },
          {
            type: 'link',
            label: 'Employee',
            userRole: loginUserData.role,
            route: '/apps/candidates/employee',
          },
        ],
      },
      {
        type: 'link',
        label: 'Advanced Search',
        userRole: '',
        route: '/apps/search-advance',
        icon: icSearch,
      },
      {
        type: 'dropdown',
        label: 'Schedule',
        userRole: '',
        // route: '/apps/calendar',
        children: [
          {
            type: 'link',
            label: 'My Availability',
            userRole: loginUserData.role,
            route: '/apps/schedule/my-availability',
          },
          {
            type: 'link',
            label: 'My Schedule',
            userRole: loginUserData.role,
            route: '/apps/schedule/my-schedule',
          }
        ],
        icon: icDateRange,
      },
      // {
      //   type: 'link',
      //   label: 'Mail',
      //   userRole: '',
      //   route: '/apps/mail',
      //   icon: icMail,
      // },
      // {
      //   type: 'link',
      //   label: 'Chat',
      //   userRole: '',
      //   route: '/apps/chat',
      //   icon: icChat,
      //   badge: {
      //     value: '16',
      //     bgClass: 'bg-cyan',
      //     textClass: 'text-cyan-contrast',
      //   },
      // },
      // {
      //   type: 'link',
      //   label: 'Campaign',
      //   userRole: '',
      //   route: '/apps/campaign',
      //   icon: icAssessment,
      // },
      // {
      //   type: 'link',
      //   label: 'Settings',
      //   route: '/apps/settings',
      //   icon: icSettings,
      // },
      // {
      //   type: 'link',
      //   label: 'table',
      //   route: '/apps/aio-table',
      //   icon: icAssigment
      // },
      {
        type: 'dropdown',
        label: 'Settings',
        icon: icSettings,
        userRole: '',
        children: [
          {
            type: 'link',
            label: 'Company',
            userRole: 5,
            route: '/apps/settings/company-setting',
          },
          {
            type: 'link',
            label: 'Users',
            userRole: loginUserData.role,
            route: '/apps/settings/users',
          },
          {
            type: 'link',
            label: 'WorkFlow',
            userRole: 5,
            route: '/apps/settings/work-flow',
          },
          {
            type: 'dropdown',
            label: 'Recruiting Preference',
            userRole: 5,
            children: [
              {
                type: 'link',
                label: 'Letters',
                userRole: 5,
                route: '/apps/settings/recruiting-preference/letter',
              },
              {
                type: 'link',
                label: 'Custom Fields',
                userRole: 5,
                route:
                  '/apps/settings/recruiting-preference/custom-field/job',
              },
              {
                type: 'link',
                label: 'Job Templates',
                userRole: 5,
                route: '/apps/settings/recruiting-preference/job-template',
              },
              {
                type: 'link',
                label: 'Questions',
                userRole: 5,
                route: '/apps/settings/recruiting-preference/questions',
              },
              {
                type: 'link',
                label: 'Interview Guides',
                userRole: 5,
                route: '/apps/settings/recruiting-preference/interview-guide',
              },
              {
                type: 'link',
                label: 'Scorecards',
                userRole: 5,
                route: '/apps/settings/recruiting-preference/scorecard',
              },
            ],
          },
          // {
          //   type: 'link',
          //   label: 'Business Units',
          //   route: '/apps/settings/business-units'
          // },
          {
            type: 'link',
            label: 'Departments',
            userRole: 5,
            route: '/apps/settings/departments',
          },
          {
            type: 'link',
            label: 'Onboarding',
            userRole: 5,
            route: '/apps/settings/onboarding',
          },
          {
            type: 'link',
            label: 'Career Page',
            userRole: 5,
            route: '/apps/settings/career-page',
          },
          // {
          //   type: 'link',
          //   label: 'Integration/market Place',
          //   userRole: 5,
          //   route: '/apps/settings/integration',
          // },
          // {
          //   type: 'link',
          //   label: 'Agency Setup',
          //   userRole: 5,
          //   route: '/apps/settings/agency-setup',
          // },
        ],
      },
      {
        type: 'dropdown',
        label: 'Reports',
        icon: icAssessment,
        userRole: '',
        children: [
          {
            type: 'link',
            label: 'Saved Reports',
            userRole: loginUserData.role,
            route: '/apps/reports/saved-report',
          },
          // {
          //   type: 'link',
          //   label: 'Candidate/Jobs Activity Reports',
          //   userRole: this.loginUserData.role,
          //   route: '/apps/reports/candidate-jobs-activity-report',
          // },
          // {
          //   type: 'link',
          //   label: 'Candidate Source Reports',
          //   userRole: this.loginUserData.role,
          //   route: '/apps/reports/candidate-source-report',
          // },
          {
            type: 'dropdown',
            label: 'Build your own',
            userRole: loginUserData.role,
            children: [
              {
                type: 'link',
                label: 'Candidate',
                userRole: loginUserData.role,
                route: '/apps/reports/candidate-report',
              },
              {
                type: 'link',
                label: 'Job',
                userRole: loginUserData.role,
                route: '/apps/reports/job-report',
              },
            ],
          },
          // {
          //   type: 'link',
          //   label: 'Candidate status',
          //   userRole: this.loginUserData.role,
          //   route: '/apps/settings/work-flow',
          // },
          // {
          //   type: 'dropdown',
          //   label: 'Job Status',
          //   userRole: this.loginUserData.role,
          //   children: [
          //     {
          //       type: 'link',
          //       label: 'Log Status',
          //       userRole: this.loginUserData.role,
          //       route: '/apps/settings/recruiting-preference/letter',
          //     },
          //   ],
          // },

          // {
          //   type: 'link',
          //   label: 'Time to Fill',
          //   userRole: this.loginUserData.role,
          //   route: '/apps/settings/departments',
          // },
          // {
          //   type: 'link',
          //   label: 'Questions',
          //   userRole: this.loginUserData.role,
          //   route: '/apps/settings/onboarding',
          // },
          {
            type: 'link',
            label: 'EEO',
            userRole: loginUserData.role,
            route: '/apps/reports/eeo',
          },
          // {
          //   type: 'link',
          //   label: 'Onboarding',
          //   userRole: this.loginUserData.role,
          //   route: '/apps/settings/integration',
          // },
          // {
          //   type: 'link',
          //   label: 'Referral',
          //   userRole: this.loginUserData.role,
          //   route: '/apps/settings/agency-setup',
          // },
        ],
      },
      {
        type: 'link',
        label: 'Help',
        icon: icHelpOutline,
        route: '/documentation/further-help',
        userRole: '',
        // fragment: 'further-help',
        // routerLinkActiveOptions: { exact: true }
      },

      // {
      //   type: 'subheading',
      //   label: 'Apps',
      //   children: [
      // {
      //   type: 'link',
      //   label: 'Jobs',
      //   route: '/apps/aio-table',
      //   icon: icAssigment
      // },
      // {
      //   type: 'link',
      //   label: 'Jobs',
      //   route: '/apps/jobs',
      //   icon: icAssigment
      // },
      // {
      //   type: 'link',
      //   label: 'Candidates',
      //   route: '/apps/contacts/grid',
      //   icon: icContacts
      // },
      // {
      //   type: 'dropdown',
      //   label: 'Candidates',
      //   icon: icContacts,
      //   children: [
      //     {
      //       type: 'link',
      //       label: 'Candidates-List',
      //       route: '/apps/contacts/grid',
      //     },
      //     // {
      //     //   type: 'link',
      //     //   label: 'List - Table',
      //     //   route: '/apps/contacts/table',
      //     // }
      //   ]
      // },
      // {
      //   type: 'dropdown',
      //   label: 'Help Center',
      //   icon: icContactSupport,
      //   children: [
      //     {
      //       type: 'link',
      //       label: 'Getting Started',
      //       route: '/apps/help-center/getting-started'
      //     },
      //     {
      //       type: 'link',
      //       label: 'Pricing & Plans',
      //       route: '/apps/help-center/pricing'
      //     },
      //     {
      //       type: 'link',
      //       label: 'FAQ',
      //       route: '/apps/help-center/faq'
      //     },
      //     {
      //       type: 'link',
      //       label: 'Guides',
      //       route: '/apps/help-center/guides'
      //     }
      //   ]
      // },
      // {
      //   type: 'link',
      //   label: 'Calendar',
      //   route: '/apps/calendar',
      //   icon: icDateRange,
      //   badge: {
      //     value: '12',
      //     bgClass: 'bg-deep-purple',
      //     textClass: 'text-deep-purple-contrast',
      //   },
      // },

      // {
      //   type: 'link',
      //   label: 'Mailbox',
      //   route: '/apps/mail',
      //   icon: icMail,
      // },
      // {
      //   type: 'dropdown',
      //   label: 'Social',
      //   icon: icPersonOutline,
      //   children: [
      //     {
      //       type: 'link',
      //       label: 'Profile',
      //       route: '/apps/social',
      //       routerLinkActiveOptions: { exact: true }
      //     },
      //     {
      //       type: 'link',
      //       label: 'Timeline',
      //       route: '/apps/social/timeline'
      //     },
      //   ]
      // },
      // {
      //   type: 'link',
      //   label: 'WYSIWYG Editor',
      //   route: '/apps/editor',
      //   icon: icChromeReaderMode
      // },
      // {
      //   type: 'dropdown',
      //   label: 'Contacts',
      //   icon: icContacts,
      //   children: [
      //     {
      //       type: 'link',
      //       label: 'List - Grid',
      //       route: '/apps/contacts/grid',
      //     },
      //     {
      //       type: 'link',
      //       label: 'List - Table',
      //       route: '/apps/contacts/table',
      //     }
      //   ]
      // },
      // {
      //   type: 'link',
      //   label: 'Scrumboard',
      //   route: '/apps/scrumboard',
      //   icon: icAssessment,
      //   badge: {
      //     value: 'NEW',
      //     bgClass: 'bg-primary',
      //     textClass: 'text-primary-contrast',
      //   }
      // },
      //   ]
      // },
      // {
      //   type: 'subheading',
      //   label: 'Pages',
      //   children: [
      //     {
      //       type: 'dropdown',
      //       label: 'Authentication',
      //       icon: icLock,
      //       children: [
      //         {
      //           type: 'link',
      //           label: 'Login',
      //           route: '/login'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Register',
      //           route: '/register'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Forgot Password',
      //           route: '/forgot-password'
      //         }
      //       ]
      //     },
      //     {
      //       type: 'link',
      //       label: 'Coming Soon',
      //       icon: icWatchLater,
      //       route: '/coming-soon'
      //     },
      //     {
      //       type: 'dropdown',
      //       label: 'Errors',
      //       icon: icError,
      //       badge: {
      //         value: '4',
      //         bgClass: 'bg-green',
      //         textClass: 'text-green-contrast',
      //       },
      //       children: [
      //         {
      //           type: 'link',
      //           label: '404',
      //           route: '/pages/error-404'
      //         },
      //         {
      //           type: 'link',
      //           label: '500',
      //           route: '/pages/error-500'
      //         }
      //       ]
      //     },
      //     {
      //       type: 'link',
      //       label: 'Pricing',
      //       icon: icAttachMoney,
      //       route: '/pages/pricing'
      //     },
      //     {
      //       type: 'link',
      //       label: 'Invoice',
      //       icon: icReceipt,
      //       route: '/pages/invoice'
      //     },
      //     {
      //       type: 'link',
      //       label: 'FAQ',
      //       icon: icHelp,
      //       route: '/pages/faq'
      //     },
      //     {
      //       type: 'link',
      //       label: 'Guides',
      //       icon: icBook,
      //       route: '/pages/guides',
      //       badge: {
      //         value: '18',
      //         bgClass: 'bg-teal',
      //         textClass: 'text-teal-contrast',
      //       },
      //     },
      //   ]
      // },
      // {
      //   type: 'subheading',
      //   label: 'UI Elements',
      //   children: [
      //     {
      //       type: 'dropdown',
      //       label: 'Components',
      //       icon: icBubbleChart,
      //       children: [
      //         {
      //           type: 'link',
      //           label: 'Overview',
      //           route: '/ui/components/overview'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Autocomplete',
      //           route: '/ui/components/autocomplete'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Buttons',
      //           route: '/ui/components/buttons'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Button Group',
      //           route: '/ui/components/button-group'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Cards',
      //           route: '/ui/components/cards'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Checkbox',
      //           route: '/ui/components/checkbox'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Dialogs',
      //           route: '/ui/components/dialogs'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Grid List',
      //           route: '/ui/components/grid-list'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Input',
      //           route: '/ui/components/input'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Lists',
      //           route: '/ui/components/lists'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Menu',
      //           route: '/ui/components/menu'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Progress',
      //           route: '/ui/components/progress'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Progress Spinner',
      //           route: '/ui/components/progress-spinner'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Radio',
      //           route: '/ui/components/radio'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Slide Toggle',
      //           route: '/ui/components/slide-toggle'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Slider',
      //           route: '/ui/components/slider'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Snack Bar',
      //           route: '/ui/components/snack-bar'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Tooltip',
      //           route: '/ui/components/tooltip'
      //         },
      //       ]
      //     },
      //     {
      //       type: 'dropdown',
      //       label: 'Forms',
      //       icon: icFormatColorText,
      //       children: [
      //         {
      //           type: 'link',
      //           label: 'Form Elements',
      //           route: '/ui/forms/form-elements'
      //         },
      //         {
      //           type: 'link',
      //           label: 'Form Wizard',
      //           route: '/ui/forms/form-wizard'
      //         }
      //       ]
      //     },
      //     {
      //       type: 'dropdown',
      //       label: 'Icons',
      //       icon: icStar,
      //       children: [
      //         {
      //           type: 'link',
      //           label: 'Material Icons',
      //           route: '/ui/icons/ic'
      //         },
      //         {
      //           type: 'link',
      //           label: 'FontAwesome Icons',
      //           route: '/ui/icons/fa'
      //         }
      //       ]
      //     },
      //     {
      //       type: 'dropdown',
      //       label: 'Page Layouts',
      //       icon: icViewCompact,
      //       children: [
      //         {
      //           type: 'dropdown',
      //           label: 'Card',
      //           children: [
      //             {
      //               type: 'link',
      //               label: 'Default',
      //               route: '/ui/page-layouts/card',
      //               routerLinkActiveOptions: { exact: true }
      //             },
      //             {
      //               type: 'link',
      //               label: 'Tabbed',
      //               route: '/ui/page-layouts/card/tabbed',
      //             },
      //             {
      //               type: 'link',
      //               label: 'Large Header',
      //               route: '/ui/page-layouts/card/large-header',
      //               routerLinkActiveOptions: { exact: true }
      //             },
      //             {
      //               type: 'link',
      //               label: 'Tabbed & Large Header',
      //               route: '/ui/page-layouts/card/large-header/tabbed'
      //             }
      //           ]
      //         },
      //         {
      //           type: 'dropdown',
      //           label: 'Simple',
      //           children: [
      //             {
      //               type: 'link',
      //               label: 'Default',
      //               route: '/ui/page-layouts/simple',
      //               routerLinkActiveOptions: { exact: true }
      //             },
      //             {
      //               type: 'link',
      //               label: 'Tabbed',
      //               route: '/ui/page-layouts/simple/tabbed',
      //             },
      //             {
      //               type: 'link',
      //               label: 'Large Header',
      //               route: '/ui/page-layouts/simple/large-header',
      //               routerLinkActiveOptions: { exact: true }
      //             },
      //             {
      //               type: 'link',
      //               label: 'Tabbed & Large Header',
      //               route: '/ui/page-layouts/simple/large-header/tabbed'
      //             }
      //           ]
      //         },
      //         {
      //           type: 'link',
      //           label: 'Blank',
      //           icon: icPictureInPicture,
      //           route: '/ui/page-layouts/blank'
      //         },
      //       ]
      //     },
      //   ]
      // },
      // {
      //   type: 'subheading',
      //   label: 'Documentation',
      //   children: [
      //     {
      //       type: 'link',
      //       label: 'Changelog',
      //       route: '/documentation/changelog',
      //       icon: icUpdate
      //     },
      //     {
      //       type: 'dropdown',
      //       label: 'Getting Started',
      //       icon: icBook,
      //       children: [
      //         {
      //           type: 'link',
      //           label: 'Introduction',
      //           route: '/documentation/introduction',
      //           fragment: 'introduction',
      //           routerLinkActiveOptions: { exact: true }
      //         },
      //         {
      //           type: 'link',
      //           label: 'Folder Structure',
      //           route: '/documentation/folder-structure',
      //           fragment: 'folder-structure',
      //           routerLinkActiveOptions: { exact: true }
      //         },
      //         {
      //           type: 'link',
      //           label: 'Installation',
      //           route: '/documentation/installation',
      //           fragment: 'installation',
      //           routerLinkActiveOptions: { exact: true }
      //         },
      //         {
      //           type: 'link',
      //           label: 'Development Server',
      //           route: '/documentation/start-development-server',
      //           fragment: 'start-development-server',
      //           routerLinkActiveOptions: { exact: true }
      //         },
      //         {
      //           type: 'link',
      //           label: 'Build for Production',
      //           route: '/documentation/build-for-production',
      //           fragment: 'build-for-production',
      //           routerLinkActiveOptions: { exact: true }
      //         }
      //       ]
      //     },
      //     {
      //       type: 'dropdown',
      //       label: 'Customization',
      //       icon: icBook,
      //       children: [
      //         {
      //           type: 'link',
      //           label: 'Configuration',
      //           route: '/documentation/configuration',
      //           fragment: 'configuration',
      //           routerLinkActiveOptions: { exact: true }
      //         },
      //         {
      //           type: 'link',
      //           label: 'Changing Styling',
      //           route: '/documentation/changing-styling-and-css-variables',
      //           fragment: 'changing-styling-and-css-variables',
      //           routerLinkActiveOptions: { exact: true }
      //         },
      //         {
      //           type: 'link',
      //           label: 'Using Custom Colors',
      //           route: '/documentation/using-custom-colors-for-the-primarysecondarywarn-palettes',
      //           fragment: 'using-custom-colors-for-the-primarysecondarywarn-palettes',
      //           routerLinkActiveOptions: { exact: true }
      //         },
      //         {
      //           type: 'link',
      //           label: 'Adding Menu Items',
      //           route: '/documentation/adding-menu-items',
      //           fragment: 'adding-menu-items',
      //           routerLinkActiveOptions: { exact: true }
      //         },
      //       ]
      //     },
      //     {
      //       type: 'link',
      //       label: 'Further Help',
      //       icon: icBook,
      //       route: '/documentation/further-help',
      //       fragment: 'further-help',
      //       routerLinkActiveOptions: { exact: true }
      //     },
      //   ]
      // },
      // {
      //   type: 'subheading',
      //   label: 'Customize',
      //   children: []
      // },
      // {
      //   type: 'link',
      //   label: 'Configuration',
      //   route: () => this.layoutService.openConfigpanel(),
      //   icon: icSettings
      // }
    ];
  }
}
